import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import JalaliDatePicker from "../../../../components/shared/jalali-datepicker";
import { formatApiDate } from "../utils/commissionValidation";
import { validateTeamShareForm } from "../utils/partnerValidation";

const TeamShareFormDialog = ({ open, onClose, parentPartnerId, childPartner, onSubmit, saving }) => {
  const [form, setForm] = useState({
    parentPartnerId: "",
    childPartnerId: "",
    sharePercentOfParentCommission: "",
    effectiveFrom: new Date(),
  });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setSubmitError(null);
    setErrors({});
    setForm({
      parentPartnerId: parentPartnerId || "",
      childPartnerId: childPartner?.id || "",
      sharePercentOfParentCommission: childPartner?.currentSharePercent ?? "",
      effectiveFrom: new Date(),
    });
  }, [open, parentPartnerId, childPartner]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
    if (submitError) setSubmitError(null);
  };

  const handleSubmit = async () => {
    const validationErrors = validateTeamShareForm(form, childPartner);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      parentPartnerId: Number(form.parentPartnerId),
      childPartnerId: Number(form.childPartnerId),
      sharePercentOfParentCommission: Number(form.sharePercentOfParentCommission),
      effectiveFrom: formatApiDate(form.effectiveFrom),
    };

    const result = await onSubmit(payload);
    if (result?.error) setSubmitError(result.error);
  };

  if (!childPartner) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تنظیم سهم پورسانت — #{childPartner.id}</DialogTitle>
      <DialogContent dividers>
        {submitError ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submitError}
          </Alert>
        ) : null}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="سهم از پورسانت والد (%)"
              type="number"
              value={form.sharePercentOfParentCommission}
              onChange={(e) => handleChange("sharePercentOfParentCommission", e.target.value)}
              fullWidth
              required
              error={Boolean(errors.sharePercentOfParentCommission)}
              helperText={errors.sharePercentOfParentCommission}
            />
          </Grid>
          <Grid item xs={12}>
            <JalaliDatePicker
              label="تاریخ شروع اعتبار"
              value={form.effectiveFrom}
              onChange={(value) => handleChange("effectiveFrom", value ? new Date(value) : null)}
              fullWidth
              error={Boolean(errors.effectiveFrom)}
              helperText={errors.effectiveFrom}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          انصراف
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TeamShareFormDialog;
